import { render } from "./CustomPostCard.vue?vue&type=template&id=e7345b64&scoped=true"
import script from "./CustomPostCard.vue?vue&type=script&lang=js"
export * from "./CustomPostCard.vue?vue&type=script&lang=js"

import "./CustomPostCard.vue?vue&type=style&index=0&id=e7345b64&scoped=true&lang=css"
import "./CustomPostCard.vue?vue&type=style&index=1&id=e7345b64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7345b64"]])

export default __exports__